import { Trans } from "@lingui/react/macro";

import { cn } from "@/shared/lib";

// Как найти сборку в игре: магазин (B) → «Сборки» → «Публичные» → номер сборки в поиск.
// По номеру находится ровно одна сборка, а названия повторяются; ссылок на сборки нет.
export const FindBuildHint = ({ className }: { className?: string }) => (
  <p className={cn("text-[13px] text-muted", className)}>
    <Trans>
      How to find it in the game:{" "}
      <kbd className="rounded border border-border-strong bg-surface px-1.5 font-mono text-xs text-foreground">
        B
      </kbd>{" "}
      → Builds → Public → paste the number into search
    </Trans>
  </p>
);
